module.exports = __webpack_public_path__ + "img/laptop_phone_shot.0c416585.png";